import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { memo } from 'react';
import { T } from '../../translation/src';

// Why a superadmin's sale has its price locked to 0: the organisation has no billing details (no Odoo customer,
// or an incomplete one), so there is nobody to invoice. Plans and projects can still be given — for free.
const NoBillingDetailsWarning_: React.FC<{ className?: string }> = ({ className }) => (
  <div className={classNames('flex items-start gap-2 rounded-md border border-warning-yellow-500 p-2 text-xs', className)}>
    <ExclamationTriangleIcon className="h-4 w-4 shrink-0 text-warning-yellow-500" />
    <span>
      <T _str="The billing details are left blank on purpose, so nothing can be invoiced: the price is locked to 0. Fill them in to charge." />
    </span>
  </div>
);

export const NoBillingDetailsWarning = memo(NoBillingDetailsWarning_);
